import { Component } from '@angular/core';

@Component({
  selector: 'app-signature-showcase',
  templateUrl: './signature-showcase.component.html',
  styleUrls: ['./signature-showcase.component.scss']
})
export class SignatureShowcaseComponent {}
